module.exports = __webpack_public_path__ + "static/media/Amazon_Web_Services-Logo.wine.59a82d54.svg";